import { render, staticRenderFns } from "./GameEditor.vue?vue&type=template&id=0c3bfd6e&scoped=true"
import script from "./GameEditor.vue?vue&type=script&lang=js"
export * from "./GameEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3bfd6e",
  null
  
)

export default component.exports